<template>
    <div class="accordion__content form__result" v-if="ready">
        <div class="grid-x grid-padding-x" v-for="(row, i) of elements" :key="i">
            <div class="form__result-item large-3 cell" :class="{'form__result-item--validation': !row.valid }">
                <b>{{row.groupName}}</b><br />
                <p class="form__result-item-summary" v-if="name !== 'activities' || row.hasNotDescribed">
                    <small v-if="row.type === 'Radio'">{{labels.selectOneItem}}</small>
                    <small v-if="row.type === 'RadioGroup'">{{labels.selectOneParentItem}}</small>
                    <small v-if="row.type === 'Checkbox'">{{labels.selectAtLeastOneItem}}</small>
                    <small v-if="row.type === 'Singletext' || row.type === 'MultipleTextComboOne' || row.type === 'MultipleTextComboTwo'">{{labels.fillRequiredFields}}</small>
                    <small v-if="row.hasNotDescribed"> {{labels.fillRequiredFieldsHasNotDescribed}}</small>
                </p>
                <p v-else-if="invalid">
                    <small>{{labels.chooseAtLeastOneIntervention}}</small>
                </p>
            </div>
            <div class="form__result-item large-7 cell" :class="{'large-9': !row.hasNotDescribed}">

                <!-- Groups -->
                <template v-if="row.type === 'Radio' || row.type === 'Checkbox' || row.type === 'RadioGroup'">
                    <ul class="mega__options" v-for="(optionGroup, i) in row.optionGroups" :key="i">

                        <!-- Options -->
                        <li class="mega__option" 
                            v-for="option in optionGroup.options" 
                            :key="option.id"
                            :tabindex="0"
                            :class="{'mega__option--title icon-circle-right': option.isTitle, 'mega__option--selected': option.isSelected}"
                            @click="toggleOption(option, optionGroup, row)"
                            @keyup.enter="toggleOption(option, optionGroup, row)">
                            {{option.name}}
                        </li>
                    </ul>
                </template>

                <!-- Textfields units -->                
                <template v-else-if="row.type === 'Singletext'">
                    <div class="form__result-mixed-items grid-x grid-padding-x">
                        <div class="form__group-item large-6 cell">
                            <input type="text" v-floatable maxlength="200"
                                :name="row.groupName + ' - Dansk'"
                                v-model="row.unit[1].text" 
                                @keydown="textChange(row)"
                                :disabled="!canEdit"
                                :id="row.groupName + '_dk'" />
                            <label :for="row.groupName + '_dk'" class="floating-label">{{labels.danish}}*</label>
                        </div>
                        <div class="form__group-item form__group-item--connect large-6 cell">
                            <input type="text" v-floatable maxlength="200"
                                :name="row.groupName + ' - English'"
                                v-model="row.unit[0].text" 
                                @keydown="textChange(row)" 
                                :disabled="!canEdit"
                                :id="row.groupName + '_uk'" />
                            <label :for="row.groupName + '_uk'" class="floating-label">{{labels.english}}*</label>
                        </div>
                    </div>
                </template>

                <!-- MultipleTextComboOne: Textfields value, comments and units  -->
                <template v-else-if="row.type === 'MultipleTextComboOne'">
                    <div class="form__result-mixed-items grid-x grid-padding-x">
                        <div class="form__group-item large-6 cell">
                            <input type="text" v-floatable
                                   v-validate="{ required: true, regex: /^[+-]?([0-9]*[,])?[0-9]+$/ }"
                                   @keydown="textChange(row)"
                                   v-model="row.totalValue"
                                   :disabled="!canEdit"
                                   :id="row.groupName + '_total'" />
                            <label :for="row.groupName + '_total'" class="floating-label" :class="{'small-text-totalvalue': row.labelmode === 'labelmode0'}">{{ row.labelmode === 'labelmode0' ? labels.totalValueEffectLength : labels.totalValue}}*</label>
                            <small class="form__result-error" v-show="!row.notDescribedSelected">{{labels.mustBeANumber}}</small>
                        </div>
                        <div class="form__group-item large-6 cell" v-if="row.labelmode !== 'labelmode0'"></div>
                        <div class="form__group-item large-6 cell">
                            <template v-if="row.labelmode !== 'labelmode0'">
                                <input type="text" v-floatable
                                       v-validate="{ required: false, regex: /^[+-]?([0-9]*[,])?[0-9]+$/ }"
                                       v-model="row.standardValue"
                                       :disabled="!canEdit"
                                       :id="row.groupName + '_error'" />
                                <label :for="row.groupName + '_error'" class="floating-label">{{ row.labelmode === 'labelmode1' ? labels.defaultError : labels.defaultDeviation }}</label>
                                <small class="form__result-error" v-show="!row.notDescribedSelected">{{labels.mustBeANumber}}</small>
                            </template>
                        </div>
                        <div class="form__group-item large-6 cell" v-if="row.labelmode !== 'labelmode0'"></div>
                        <div class="form__group-item large-6 cell">
                            <input type="text" v-floatable maxlength="200"
                                   v-model="row.unit[1].text"
                                   @keydown="textChange(row)"
                                   :disabled="!canEdit"
                                   :id="row.groupName + '_unitdk'" />
                            <label :for="row.groupName + '_unitdk'" class="floating-label" :class="{'small-text-units': row.labelmode === 'labelmode0'}">{{ row.labelmode === 'labelmode0' ? labels.unitDkEffectLength : labels.unitDk}}*</label>
                        </div>
                        <div class="form__group-item form__group-item--connect large-6 cell">
                            <input type="text" v-floatable maxlength="200"
                                   v-model="row.unit[0].text"
                                   @keydown="textChange(row)"
                                   :disabled="!canEdit"
                                   :id="row.groupName + '_unituk'" />
                            <label :for="row.groupName + '_unituk'" class="floating-label" :class="{'small-text-units': row.labelmode === 'labelmode0'}">{{ row.labelmode === 'labelmode0' ? labels.unitUkEffectLength : labels.unitUk}}*</label>
                        </div>
                        <div class="form__group-item large-6 cell">
                            <input type="text" v-floatable maxlength="200"
                                   v-model="row.comment[1].text"
                                   :disabled="!canEdit"
                                   :id="row.groupName + '_commentdk'" />
                            <label :for="row.groupName + '_commentdk'" class="floating-label">{{labels.possiblyRemarksDk}}</label>
                        </div>
                        <div class="form__group-item form__group-item--connect large-6 cell">
                            <input type="text" v-floatable maxlength="200"
                                   v-model="row.comment[0].text"
                                   :disabled="!canEdit"
                                   :id="row.groupName + '_commentuk'" />
                            <label :for="row.groupName + '_commentuk'" class="floating-label">{{labels.possiblyRemarksUk}}</label>
                        </div>
                    </div>
                </template>


                <!-- MultipleTextComboTwo: Textfields value, comments and units  -->
                <template v-else-if="row.type === 'MultipleTextComboTwo'">
                    <div class="form__result-mixed-items grid-x grid-padding-x">
                        <div class="form__group-item large-6 cell">
                            <input type="text" v-floatable
                                   v-validate="{ required: false, regex: /^[+-]?([0-9]*[,])?[0-9]+$/ }"
                                   @keydown="textChange(row)"
                                   v-model="row.totalValueBefore"
                                   :disabled="!canEdit"
                                   :id="row.groupName + '_totalBefore'" />
                            <label :for="row.groupName + '_totalBefore'" class="floating-label">{{labels.totalValueBefore}}</label>
                            <small class="form__result-error" v-show="!row.notDescribedSelected">{{labels.mustBeANumber}}</small>
                        </div>
                        <div class="form__group-item large-6 cell"></div>
                        <div class="form__group-item large-6 cell">
                            <input type="text" v-floatable
                                   v-validate="{ required: false, regex: /^[+-]?([0-9]*[,])?[0-9]+$/ }"
                                   @keydown="textChange(row)"
                                   v-model="row.totalValueAfter"
                                   :disabled="!canEdit"
                                   :id="row.groupName + '_totalAfter'" />
                            <label :for="row.groupName + '_totalAfter'" class="floating-label">{{labels.totalValueAfter}}</label>
                            <small class="form__result-error" v-show="!row.notDescribedSelected">{{labels.mustBeANumber}}</small>
                        </div>
                        <div class="form__group-item large-6 cell"></div>
                        <div class="form__group-item large-6 cell">
                            <input type="text" v-floatable
                                   v-model="row.standardValueBefore"
                                   @keydown="textChange(row)"
                                   v-validate="{ required: false, regex: /^[+-]?([0-9]*[,])?[0-9]+$/ }"
                                   :disabled="!canEdit"
                                   :id="row.groupName + '_standardBefore'" />
                            <label :for="row.groupName + '_standardBefore'" class="floating-label">{{labels.standardDeviationBefore}}</label>
                            <small class="form__result-error" v-show="!row.notDescribedSelected">{{labels.mustBeANumber}}</small>
                        </div>
                        <div class="form__group-item large-6 cell"></div>
                        <div class="form__group-item large-6 cell">
                            <input type="text" v-floatable
                                   v-model="row.standardValueAfter"
                                   @keydown="textChange(row)"
                                   v-validate="{ required: false, regex: /^[+-]?([0-9]*[,])?[0-9]+$/ }"
                                   :disabled="!canEdit"
                                   :id="row.groupName + '_standardAfter'" />
                            <label :for="row.groupName + '_standardAfter'" class="floating-label">{{labels.standardDeviationAfter}}</label>
                            <small class="form__result-error" v-show="!row.notDescribedSelected">{{labels.mustBeANumber}}</small>
                        </div>
                        <div class="form__group-item large-6 cell"></div>
                        <div class="form__group-item large-6 cell">
                            <input type="text" v-floatable maxlength="200"
                                   v-model="row.unit[1].text"
                                   @keydown="textChange(row)"
                                   :disabled="!canEdit"
                                   :id="row.groupName + '_unitdk'" />
                            <label :for="row.groupName + '_unitdk'" class="floating-label">{{labels.unitDk}}</label>
                        </div>
                        <div class="form__group-item form__group-item--connect large-6 cell">
                            <input type="text" v-floatable maxlength="200"
                                   v-model="row.unit[0].text"
                                   @keydown="textChange(row)"
                                   :disabled="!canEdit"
                                   :id="row.groupName + '_unituk'" />
                            <label :for="row.groupName + '_unituk'" class="floating-label">{{labels.unitUk}}</label>
                        </div>

                    </div>
                </template>


            </div>
            <div class="form__result-item large-2 cell" v-if="row.hasNotDescribed">
                <a tabindex="0" class="text--gray"
                    :class="{'text--blue': row.notDescribedSelected}"
                    @click="toggleNotDescribedOption(row)"
                    @keyup.enter="toggleNotDescribedOption(row)"
                    >
                    {{labels.notDescribed}}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import { each, some, debounce, find } from "lodash";
export default {
    props: ["elements", "name", "canEdit"],
    data() {
        return {
            invalidGroups: [],
            invalid: true,
            ready: false
        };
    },
    methods: {
        showInvalid(name) {
            return this.errors.has(name);
        },
        checkIfValid(row, update) {
            var valid = false;

            if (this.name !== "activities" || row.hasNotDescribed) {
                switch (row.type) {
                    // Radio button rules:
                    // At least one option or "Ikke beskrevet" must be selected
                    case "Radio":
                        valid =
                            this.any(row.optionGroups) ||
                            row.notDescribedSelected;
                        break;

                    // Checkbox rules:
                    // if there is a "Ikke beskrevet" option at least one option must be selected
                    case "Checkbox":
                        valid = this.any(row.optionGroups) || row.notDescribedSelected;
                        break;

                    // SingleText rules:
                    // Both fields are required unless "Ikke beskrevet" is selected
                    case "Singletext":
                        valid =
                            this.noNullOrEmpty([
                                row.unit[0].text,
                                row.unit[1].text
                            ]) || row.notDescribedSelected;
                        break;

                    // RadioGroup rules:
                    // Only one family can be selected
                    case "RadioGroup":
                        valid = this.any(row.optionGroups) || row.notDescribedSelected;
                        break;

                    // MultipleTextComboOne rules:
                    // Three fields are required unless "Ikke beskrevet" is selected
                    case 'MultipleTextComboOne':
                        var numPat = new RegExp(/^[+-]?([0-9]*[,])?[0-9]+$/);
                        var noEmpty = this.noNullOrEmpty([
                                row.totalValue,
                                row.unit[0].text,
                                row.unit[1].text
                            ]);
                        valid = noEmpty ? numPat.test(row.totalValue) : row.notDescribedSelected;
                        break;


                    // MultipleTextComboTwo rules:
                    // Three fields are required unless "Ikke beskrevet" is selected
                    case 'MultipleTextComboTwo':
                        var numPat = new RegExp(/^[+-]?([0-9]*[,])?[0-9]+$/);

                        var anyNoEmpty =
                            this.noNullOrEmpty([row.totalValueBefore]) ||
                            this.noNullOrEmpty([row.totalValueAfter]) ||
                            this.noNullOrEmpty([row.standardValueBefore]) ||
                            this.noNullOrEmpty([row.standardValueAfter]) ||
                            this.noNullOrEmpty([row.unit[0].text]) ||
                            this.noNullOrEmpty([row.unit[1].text]);

                        var isTotalValueBeforeValidIfSelected = this.noNullOrEmpty([row.totalValueBefore]) ? numPat.test(row.totalValueBefore) : true;
                        var isTotalValueAfterValidIfSelected = this.noNullOrEmpty([row.totalValueAfter]) ? numPat.test(row.totalValueAfter) : true;
                        var isStandardValueBeforeValidIfSelected = this.noNullOrEmpty([row.standardValueBefore]) ? numPat.test(row.standardValueBefore) : true;
                        var isStandardValueAfterValidIfSelected = this.noNullOrEmpty([row.standardValueAfter]) ? numPat.test(row.standardValueAfter) : true;

                        valid = anyNoEmpty
                            ? (isTotalValueBeforeValidIfSelected && isTotalValueAfterValidIfSelected && isStandardValueBeforeValidIfSelected && isStandardValueAfterValidIfSelected)
                            : row.notDescribedSelected;
                        break;
                }
            } else {
                // Validation rules for activities:
                // One must be selected from any group
                each(this.elements, group => {
                    each(group.optionGroups, optionGroup => {
                        if (!valid && !optionGroup.hasNotDescribed) {
                            valid = some(optionGroup.options, { isSelected: true });
                        }
                    });
                });

                each(this.elements, group => {
                    if (!group.hasNotDescribed) {
                        group.valid = valid;
                    }
                });
            }
            row.valid = valid;
            this.$forceUpdate();
            if (update) this.updateValidationSummary()
        },

        any(optionGroups) {
            var valid = false;
            each(optionGroups, item => {
                if (some(item.options, { isSelected: true })) {
                    valid = true;
                    return;
                }
            });
            return valid;
        },
        noNullOrEmpty(values) {
            var valid = true;            
            each(values, item => {
                valid = valid && typeof item === "string" && item.length > 0;
            });
            return valid;
        },
        toggleOption(option, optionGroup, row) {
            // cancel if read only
            if (!this.canEdit) return;

            // deselect not described
            row.notDescribedSelected = false;

            // deselect other option if radio
            if (row.type === 'Radio') each(row.optionGroups[0].options, (item) => { item.isSelected = false; });

            // deselect other families if radiogroup
            if (row.type === 'RadioGroup'){
                each(row.optionGroups, (group) => {
                    each(group.options, (item) => { 
                        if(item.id !== option.id) item.isSelected = false; 
                    });
                });
            }

            // toggle option
            option.isSelected = !option.isSelected;

            // select related parents OR deselect related children
            if (option.isSelected && option.parrentId !== null) {
                selectParentOption(option.parrentId, optionGroup)
            } else if (!option.isSelected) {
                deselectChildOption(option.id, optionGroup)
            }
            this.checkIfValid(row, true);
        },
        toggleNotDescribedOption(row) {
            if (!this.canEdit) return;
            row.notDescribedSelected = !row.notDescribedSelected;

            // clear selection
            each(row.optionGroups, group => {
                each(group.options, option => {
                    option.isSelected = false;
                });
            });

            // clear inputs
            each(['standardValue', 'totalValue', 'totalValueAfter', 'totalValueBefore', 'standardValueBefore', 'standardValueAfter'], (item) => {
                if (row.hasOwnProperty(item)) row[item] = '';
            })

            // clear inputs
            each(['comment', 'unit'], (item) => {
                if (row.hasOwnProperty(item)) {
                    row[item][0].text = '';
                    row[item][1].text = '';
                } 
            })

            this.checkIfValid(row, true);
        },
        textChange: debounce(function(row) {
            row.notDescribedSelected = false;
            this.checkIfValid(row, true);
        }, 500),
        updateValidationSummary() {
            // highligt if any row is invalid
            this.invalid = some(this.elements, { valid: false });

            this.$emit("setInvalidState", {
                name: this.name,
                valid: !this.invalid
            });
        }
    },
    computed:{
        labels() {
            return this.$store.state.labels["pages.mypage.suggestStudyElements"] || {};
        },
    },
    mounted() {
        this.$store.dispatch('getLabels', { label: 'pages.mypage.suggestStudyElements' });
        each(this.elements, (row) => {
            this.checkIfValid(row, false);
        })
        this.updateValidationSummary();
        this.ready = true;
    }
};

// find parent option and select. loop until null
function selectParentOption(id, group) {
    var parent = find(group.options, { id: id });
    if (typeof parent !== 'undefined') {
        parent.isSelected = true;
        if (parent.parrentId !== null) selectParentOption(parent.parrentId, group);
    }
}

// find child option with parentId = id and deselect. loop until null
function deselectChildOption(id, group) {
    each(group.options, (child) => {
        if (child.parrentId === id) {
            child.isSelected = false;
            deselectChildOption(child.id, group)
        }
    })
}
</script>



// WEBPACK FOOTER //
// src/components/my-pages/EditStudyFormElements.vue